import type {
  ActiveAntePostBasedMyBetPart,
  ActiveEventBasedMyBetPart,
  ActiveMeetingBasedMyBetPart,
  MyBetPart
} from '@ps/web-sports-api-types';

export function isActiveEventBasedMyBetPart(part: MyBetPart): part is ActiveEventBasedMyBetPart {
  return 'competitionId' in part;
}

export function isActiveAntePostBasedMyBetPart(
  part: MyBetPart
): part is ActiveAntePostBasedMyBetPart {
  return 'eventSlug' in part && part.marketType === 'ANTEPOST_WIN';
}

export function isActiveMeetingBasedMyBetPart(
  part: MyBetPart
): part is ActiveMeetingBasedMyBetPart {
  return 'raceId' in part;
}
